import { Box } from '@material-ui/core'
import React from 'react'

type Props = {
  height: number
}

export const Spacer = ({ height }: Props) => <Box height={height} />
